import DataRoomActionMenu from './DataRoomActionMenu.component';

export default DataRoomActionMenu;
